
<div class="floatinghead be-tab-02 clearfix" id="property-dashboard-innertabs">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a [class.active]="dashboardActiveTab == dashboardTabs.Dashboard" href="javascript:void(0);" (click)="onDashboardTabClick(dashboardTabs.Dashboard);" class="nav-link active">
        Dashboard
      </a>
    </li>
    <li *ngIf="prospectTabVisibility" class="nav-item">
      <a [class.active]="dashboardActiveTab == dashboardTabs.Prospects" href="javascript:void(0);" (click)="onDashboardTabClick(dashboardTabs.Prospects);" class="nav-link">
        Prospects
      </a>
    </li>
    <li class="nav-item">
      <a [class.active]="dashboardActiveTab == dashboardTabs.Files" href="javascript:void(0);" (click)="onDashboardTabClick(dashboardTabs.Files);" class="nav-link">
        Files
      </a>
    </li>
    <li class="nav-item" *ngIf="_authenticationService.Broker() || _authenticationService.Admin()|| _authenticationService.SuperAdmin()">
      <a [class.active]="dashboardActiveTab == dashboardTabs.DocAccess" href="javascript:void(0);" (click)="onDashboardTabClick(dashboardTabs.DocAccess);" class="nav-link">
        Document Access<sup class="message-count ml-auto" *ngIf="property.DocAccessRequestCount > 0">{{property.DocAccessRequestCount > 99 ? '99+':property.DocAccessRequestCount}}</sup>
      </a>
    </li>
    <li class="nav-item">
      <a [class.active]="dashboardActiveTab == dashboardTabs.DealContacts" href="javascript:void(0);" (click)="onDashboardTabClick(dashboardTabs.DealContacts);" class="nav-link">
        Deal Contacts
      </a>
    </li>
    <li class="nav-item" *ngIf="_authenticationService.Broker() || _authenticationService.Admin()|| _authenticationService.SuperAdmin()">
      <a [class.active]="dashboardActiveTab == dashboardTabs.People" href="javascript:void(0);" (click)="onDashboardTabClick(dashboardTabs.People);" class="nav-link">
        Seller Access
      </a>
    </li>
  </ul>
</div>

<!--{{property | json}}-->
<div class="row">
  <!--Dashboard start here-->
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == dashboardTabs.Dashboard">
      <div class="tabheadingsoverflow">
        <app-dashboard [propertyGuid]="propertyGuid" [propertyId]="propertyId" [property]="property" [offerstatusid]="offerstatusid" [offerGuid]="offerGuid" (loadProspectTab)="loadProspect($event)" (showPlaceOffer)="showPlaceOffer($event)" [isFromPortfolio]="this.property.PropertyStatus == 'Off-Market' && !dashboardTabVisibility"></app-dashboard>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == dashboardTabs.Files">
      <app-property-dashboard-file class="property-dashboard-files" [BackgroundFileStoring]="1" [propertyId]="propertyId" [property]="property"></app-property-dashboard-file>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == dashboardTabs.Prospects">
      <div class="tabheadingsoverflow">
        <app-prospects [propertyId]="propertyId" [IsPortfolio]="IsPortfolio" [property]="property" [isFromDashboard]="false" [propsectMennuId]="propsectMennuId"></app-prospects>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == dashboardTabs.DealContacts">
      <div class="tabheadingsoverflow">
        <app-deal-contacts [propertyId]="propertyId" [IsPDeleted]="property.IsDeleted"></app-deal-contacts>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == dashboardTabs.DocAccess && (_authenticationService.Broker() || _authenticationService.Admin()|| _authenticationService.SuperAdmin())">
      <div class="tabheadingsoverflow">
        <doc-access-listing [property]="property" [AccessAdded]="AccessAdded" [IsFromProperty]="IsFromSource"></doc-access-listing>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == dashboardTabs.People">
      <div class="tabheadingsoverflow">
        <app-seller-listings [propertyId]="propertyId"></app-seller-listings>
      </div>
    </div>
  </div>
</div>

